import { render, staticRenderFns } from "./likeList.vue?vue&type=template&id=2d817396"
import script from "./likeList.vue?vue&type=script&lang=js"
export * from "./likeList.vue?vue&type=script&lang=js"
import style0 from "./likeList.vue?vue&type=style&index=0&id=2d817396&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports